import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import styles from '../MyEquipment.module.scss';

type CatButtonProps = ComponentProps<typeof CatHeading> & {
  onBackButtonClick?: () => void;
};

export const MyEquipmentHeader: FC<PropsWithChildren<CatButtonProps>> = ({
  children,
  variant,
  className,
  level = 'h2',
  onBackButtonClick
}) => {
  return (
    <div
      className={`${styles['drawer']} ${className} align-items-center`}
      slot="header"
    >
      {!!onBackButtonClick && (
        <CatButton
          className="me-4"
          hideText
          onClick={onBackButtonClick}
          variant="ghost"
          data-testid="back-arrow-button"
        >
          <CatIconArrowBack slot="before" />
        </CatButton>
      )}
      <div className="d-flex">
        <CatHeading variant={variant} level={level}>
          {children}
        </CatHeading>
      </div>
    </div>
  );
};
